import React, { useState, useEffect } from "react";
import "./settings.scss";
import Account from "../../components/Settings/Account/Account";
import Menu from "../../components/Menu/Menu";
import DataSource from "../../components/Settings/DataSource/DataSource";
import { useDispatch, useSelector } from "react-redux";
import { fetchDashboardData } from "../../redux/actions/dashboardActions";
import { useLocation, useNavigate, Navigate } from "react-router-dom";

const Settings = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(location.state?.activeTab || 1);

  const dispatch = useDispatch();
  const {
    loading,
    error,
    data: dashboardData,
  } = useSelector((state) => state.dashboard);

  const tabs = ["Data sources", "Account"];

  useEffect(() => {
    dispatch(fetchDashboardData());
  }, [dispatch]);

  useEffect(
    (activeTab) => {
      // Update `activeTab` whenever location.state.activeTab changes
      if (
        location.state?.activeTab !== undefined &&
        location.state.activeTab !== activeTab
      ) {
        setActiveTab(location.state.activeTab);
      }
    },
    [location.state?.activeTab],
  );

  const handleTabChange = (index) => {
    setActiveTab(index);
    navigate("/settings", { state: { activeTab: index } }); // Push activeTab to location.state
  };

  if (
    location.pathname === "/settings" &&
    location.state?.activeTab === undefined
  ) {
    return <Navigate to="/settings" state={{ activeTab: 1 }} replace />;
  }

  if (loading) {
    return <div>Loading dashboard data...</div>;
  }

  const renderContent = () => {
    switch (activeTab) {
      case 0:
        return <DataSource dashboardData={dashboardData}></DataSource>;
      case 1:
        return <Account dashboardData={dashboardData}></Account>;
      // case 2:
      //   return (
      //     <ProfileSettings dashboardData={dashboardData}></ProfileSettings>
      //   );
      default:
        return <Account dashboardData={dashboardData}></Account>;
    }
  };

  return (
    <div className="settings-page dashboard">
      <div className="profile-column">
        <Menu dashboardData={dashboardData} />
      </div>

      <div className="settings-page-content">
        <h1 className="tit-settings-page">Settings</h1>
        <div className="settings-page-tabs">
          {tabs.map((tab, index) => (
            <button
              key={index}
              className={activeTab === index ? "active" : ""}
              onClick={() => handleTabChange(index)} // Use the new function
            >
              {tab}
            </button>
          ))}
        </div>
        <div className="settings-page-tabs-content">
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default Settings;
